import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import {
  ToggleButtonReuseTwo,
  ToggleButtonWithYesNo,
} from "../../../AllButton/ToggleButtonReuse";

import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../../store/actions/authAction";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import isEmpty from "../../../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import store from "../../../../../../../store/store";
import { UPDATE_SUBSCRIPTION_TYPE } from "../../../../../../../store/types";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import AddBankDetails from "./AddBankDetails";
import { Col, Row } from "react-bootstrap";
import LeftSideNavigation from "../../../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../../../../../vendorDashboardComponents/navigationSection/RightSideNavigation";
// import MassCompletion from "../MassCompletion";

export const CuratedOfflineExperienceManagement = (props) => {
  const history = useHistory();
  const [disabled, setDisable] = useState(
    history?.location?.state?.access === "View" ? true : false
  );
  const [state, setState] = useState({
    auto_cancel_open_restaurant: 5,
    auto_cancel_close_restaurant: 5,
    booking_enabled: false,
  });

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const onCasualOnlineEventSubmitClick = () => {
    let values = {
      value: true,
      ...state,
    };
    const token = props?.auth?.user?.accessToken;
    const subscriptionId = props?.subscription?._id;
    let formData = props?.allSubscriptionsData;

    formData.experience_management.offline_experience.curated.value =
      values?.value;
    formData.experience_management.offline_experience.curated.auto_cancel_open_restaurant =
      values?.auto_cancel_open_restaurant;
    formData.experience_management.offline_experience.curated.auto_cancel_close_restaurant =
      values?.auto_cancel_close_restaurant;

    let sendData = {
      ...props.subscription,
    };
    if (props.subscription?.multi_service_business) {
      sendData.multi_service_business_status = formData;
    } else if (props.subscription?.fast_food_dining) {
      sendData.fast_food_dining_status = formData;
    } else {
      sendData.casual_dining_status = formData;
    }
    props.update_new_subscription_for_vendor(
      subscriptionId,
      sendData,
      token,
      onSuccess
    );
  };

  const onSuccess = (e) => {
    Alert.success("<h4>Changes submitted successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    history.goBack();
  };

  useEffect(() => {
    setState({
      ...state,
      auto_cancel_open_restaurant:
        props?.subscriptionData?.offline_experience?.curated
          ?.auto_cancel_open_restaurant,
      auto_cancel_close_restaurant:
        props?.subscriptionData?.offline_experience?.curated
          ?.auto_cancel_close_restaurant,
    });
  }, [props?.subscriptionData]);

  const backButtonHandler = (e) => {
    e.preventDefault();

    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
    history.goBack();
  };

  if (props?.auth?.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        {props?.auth?.user?.VendorUser?.have_vendor_submitted_details ? (
          <div className="container-fluid">
            <Row>
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
              <div className="right-side-panel">
                <RightSideNavigation
                  leftText="vendorReview"
                  actionPerform="button"
                  backButtonLink={() => history.goBack()}
                  displayText="Back"
                />
                <Col
                  lg={12}
                  className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 new-subscription-onboarding-component"
                >
                  <div className="inside-subscription-event-section">
                    <InnerComponent
                      state={state}
                      disabled={disabled}
                      handleChange={handleChange}
                      backButtonHandler={backButtonHandler}
                      onCasualOnlineEventSubmitClick={
                        onCasualOnlineEventSubmitClick
                      }
                    />
                  </div>
                </Col>
              </div>
            </Row>
          </div>
        ) : (
          // Onboarding Screen
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
              >
                <Media query="(min-width: 992px)">
                  <div className="col-12">
                    <BackLogoIconButton
                      displayBackText={true}
                      displayArrow={true}
                      workWithLinkORClick={true}
                      notDisplaProgressBar={true}
                      backButtonClicked={(e) => backButtonHandler(e)}
                    />
                  </div>
                </Media>

                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    link={false}
                    onClick={(e) => backButtonHandler(e)}
                  />
                </Media>
                <React.Fragment>
                  <div className="onboarding_process_screen-button-map inside-subscription-event-section">
                    <InnerComponent
                      state={state}
                      disabled={disabled}
                      handleChange={handleChange}
                      backButtonHandler={backButtonHandler}
                      onCasualOnlineEventSubmitClick={
                        onCasualOnlineEventSubmitClick
                      }
                    />
                  </div>
                </React.Fragment>
              </div>
              <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                <SliderReusableComponent
                  // displayBarButton={true}
                  displayHamburger={true}
                  paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-02.svg")}
                />
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
};

CuratedOfflineExperienceManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state?.auth,
  subscription:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  subscriptionData: state?.onboarding?.onboard_subscription_details
    ?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status?.experience_management
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ?.experience_management
    : state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.experience_management,
  allSubscriptionsData: state?.onboarding?.onboard_subscription_details
    ?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
    : state?.onboarding?.onboard_subscription_details?.casual_dining_status,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(CuratedOfflineExperienceManagement));

const InnerComponent = ({
  state,
  disabled,
  handleChange,
  backButtonHandler,
  onCasualOnlineEventSubmitClick,
}) => {
  return (
    <React.Fragment>
      <TopTextReusableComponent
        headingText="Events Management"
        headingParagraph="(Note: Events are in a physical venue)"
      />
      <div className="col-12 p-0 mt-2">
        <div>
          <div className="row margin-between-toggler">
            <div className="col-6">
              <div className="f15-700">Auto Cancel</div>
              <div className="f11-400 opacity5 w-75">
                (Acceptance period for pending requests when restaurant is open)
              </div>
            </div>
            <div className="col-5">
              <div className="row align-items-center">
                <div className="col-6 p-0">
                  <FormControl
                    variant="outlined"
                    className={"w-100"}
                    disabled={disabled}
                  >
                    <Select
                      name="auto_cancel_open_restaurant"
                      id="auto_cancel_open_restaurant"
                      className={`w-100`}
                      onChange={handleChange}
                      value={state?.auto_cancel_open_restaurant}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="col-6">
                  <p className="f12-500">Minutes</p>
                </div>
                <div className="col-6"></div>
              </div>
            </div>
          </div>
          <div className="row margin-between-toggler">
            <div className="col-6">
              <div className="f15-700">Auto Cancel</div>
              <div className="f11-400 opacity5 w-75">
                (Acceptance period for pending requests when restaurant is
                close)
              </div>
            </div>
            <div className="col-5">
              <div className="row align-items-center">
                <div className="col-6 p-0">
                  <FormControl
                    variant="outlined"
                    className={"w-100"}
                    disabled={disabled}
                  >
                    <Select
                      name="auto_cancel_close_restaurant"
                      id="auto_cancel_close_restaurant"
                      className={`w-100`}
                      onChange={handleChange}
                      value={state?.auto_cancel_close_restaurant}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="col-6">
                  <p className="f12-500">Minutes</p>
                </div>
                <div className="col-6"></div>
              </div>
            </div>
          </div>
          <hr />
          <div>
            <div className="f16-700">
              Do you want to use Table/Seat Management for Experiences ?
            </div>
            <div className="row mt-3">
              <div className="col-7">
                <div className="f14-700">
                  Enable Table or Seat Management for your Experience
                </div>
              </div>
              <div className="col-5">
                <div className="f14-700" style={{ color: "#dc3545" }}>
                  Coming Soon...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="onboarding-map-setup-screen-autodetect-button mt-5">
        <ReusableOnboardingButton
          buttonTitle="Back Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
          buttonText="Back"
          buttonType="button"
          onClick={(e) => backButtonHandler(e)}
        />
        {!disabled && (
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Done"
            buttonType="button"
            onClick={onCasualOnlineEventSubmitClick}
            disabled={disabled}
          />
        )}
      </div>
    </React.Fragment>
  );
};
